// utils
import isMobile from '../utils/is-mobile';
import { toggleModal } from '../utils/modal';

// adjust display of certificates
const sectionCertificates = document.querySelectorAll('.certificates');

const certificateCount = 'certificate__count';
let onMobile = isMobile();
let windowWidth = window.innerWidth;

const addExcessIndicator = (certificates, count) => {
  const span = document.createElement('button');
  span.setAttribute('class', certificateCount);
  span.innerHTML = `+${count}`;
  certificates.appendChild(span);
};

const removeExcessIndicator = (certificates) => {
  const count = certificates.querySelector(`.${certificateCount}`);
  if (count) {
    count.remove();
  }
};

const showAllCertificates = (certificates) => {
  const modal = certificates.nextElementSibling;
  // in case something else sneaks in
  if (!modal.classList.contains('modal--certificates')) {
    return;
  }

  toggleModal(modal, ...certificates.children);
};

const getCertificatesType = (certificates) => {
  // check for type, based on where are they displayed
  let type;

  [...certificates.classList].forEach((c) => {
    if (type == null) {
      const certificatesMatch = c.match(/^certificates--([a-z-]+)$/);
      type = certificatesMatch ? certificatesMatch[1] : null;
    }
  });

  return type;
};

// adjust number of visible certificates based on window size
const countCertificates = (certificates, type) => {
  const displayedOnPage = type === 'on-page';

  // reset in case we're resizing
  let visibleCertificates = 0;
  // get logos again
  const logos = [...certificates.querySelectorAll('.certificate')];
  // reset visible items' styling
  logos.forEach((l) => {
    l.style.display = 'block';
  });

  // determine how many items should be visible (different based on type)
  if (onMobile) {
    visibleCertificates = displayedOnPage ? 4 : 3;
  } else {
    visibleCertificates = displayedOnPage ? 8 : 4;
  }

  const certificatesCount = logos.length;
  const excess = certificatesCount - visibleCertificates;
  const hasExcess = certificatesCount > visibleCertificates;

  // set the number of columns for grid
  certificates.style.setProperty(
    '--certificates-count',
    hasExcess ? visibleCertificates + 1 : 'auto',
  );

  if (certificatesCount) {
    // toggle 'items left' indicator
    if (hasExcess) {
      addExcessIndicator(certificates, excess);
    } else {
      removeExcessIndicator(certificates);
    }

    // toggle class if there are not enough items
    certificates.classList.toggle('certificates--few', !hasExcess);
    // hide 'items left' items
    logos.slice(-1 * excess).forEach((l) => {
      l.style.display = hasExcess ? 'none' : 'block';
    });
  }
};

(() => {
  if (sectionCertificates.length) {
    sectionCertificates.forEach((certificates) => {
      const type = getCertificatesType(certificates);

      if (!certificates.classList.contains('certificates--in-modal')) {
        countCertificates(certificates, type);
      }

      // we're not going live with certificates future @todo
      // (a content + implementation issue)
      // eslint-disable-next-line no-constant-condition
      if (false && type === 'on-page') {
        showAllCertificates(certificates, type);
      }
    });
  }
})();

// add resize listener to update values if needed
if (sectionCertificates.length) {
  window.addEventListener('resize', () => {
    if (window.innerWidth !== windowWidth) {
      // update the window width for next time
      windowWidth = window.innerWidth;
      // update the on mobile check
      onMobile = isMobile();
      // recount displayed certificates
      sectionCertificates.forEach((certificates) => {
        // remove on resize, bc values change
        removeExcessIndicator(certificates);
        // count again, bc values change
        if (!certificates.classList.contains('certificates--in-modal')) {
          countCertificates(certificates, getCertificatesType(certificates));
        }
      });
    }
  });
}
